/**
 * Block 12 Section Д Lighting — shared row specs.
 *
 * Эти specs используются:
 *   - `<SectionLighting>` для рендера 4 fixed rows
 *   - `anketaReducer` (TOGGLE_LIGHTING on=true) для seed'а `lightingQuantities`
 *     значениями `defaultQty` (per методика §1.4.1 фиксированные quantities).
 *
 * Выделено в отдельный модуль, чтобы reducer не зависел от UI-компонента
 * (направление dep: UI и reducer → этот module, не UI ← reducer).
 *
 * Source: docs/prototypes/screen-2.12.2-kitchen-calc.html lines 493-496.
 * Reference: ADR-0020 §Q1, методика §1.4.1.
 */

export interface LightingRowSpec {
  readonly id: string;
  readonly label: string;
  readonly unit: string;
  /** Default qty per методика §1.4.1 (user может override через NumberInput). */
  readonly defaultQty: number;
}

export const LIGHTING_ROW_SPECS: readonly LightingRowSpec[] = [
  { id: 'led-strip', label: 'LED-лента', unit: 'м', defaultQty: 1 },
  { id: 'profile-3m', label: 'Профиль 3 м', unit: 'шт', defaultQty: 1 },
  { id: 'sensor-switch', label: 'Сенсорный включатель', unit: 'шт', defaultQty: 1 },
  { id: 'transformer', label: 'Трансформатор', unit: 'шт', defaultQty: 1 },
] as const;
